import connected from "standard/connected";
import define from "standard/define";
import on from "standard/on";
import paint from "standard/paint";
import repaint from "standard/repaint";
import trait from "standard/trait";
import content from "./content";
import style from "./style";

@define("m-recommendations")
class Recommendations extends HTMLElement {
  get content() {
    return content[0];
  }

  constructor() {
    super();
    this.attachShadow({ mode: "open" });
  }

  @connected
  @paint
  [trait.template]() {
    return `
      <article class="${style.recommendation}">
        <button class="${style.recommendation__button}" id="prev">
          <img src="//donna.sistemadulino.com.br/site/recommendation/back.png" class=${style.recommendation__arrow} alt="Anterior" loading="lazy">
        </button>

        <aside class="${style.recommendation__aside}">
          <figure class="${style.recommendation__stars}">
            <img src="//donna.sistemadulino.com.br/site/recommendation/Stars.png" alt="Estrela" loading="lazy">
            <figcaption>
              <p class="${style.recommendation__description}">
                ${this.content.review}
              </p>
            </figcaption>
          </figure>

          <figure class="${style.recommendation__figure}">
            <img src="${this.content.image}" class="${style.recommendation__src}" alt="Imagem das pessoas responsáveis pelo depoimento" loading="lazy">
            <figcaption class="${style.recommendation__figcaption}">
              <strong class="${style.recommendation__name}">
                ${this.content.name}
              </strong>
              <span class="${style.recommendation__status}">
                ${this.content.status}
              </span>
            </figcaption>
          </figure>
        </aside>

        <button class='${style.recommendation__button}' id="next">
          <img src="//donna.sistemadulino.com.br/site/recommendation/next.png" class=${style.recommendation__arrow} alt="Próximo" loading="lazy">
        </button>
      </article>
    `;
  }

  @on.click("button#prev")
  @repaint
  onPrev() {
    content.unshift(content.pop() as any);
  }

  @on.click("button#next")
  @repaint
  onNext() {
    content.push(content.shift() as any);
  }
}

export default Recommendations;
